import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  fetchLeaveRequest, updateLeaveAction } from "../../../service/api";


export const getLeaveRequest = createAsyncThunk(
    "leave/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchLeaveRequest(params)
            console.log("leave request data ", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const editLeaveRequest = createAsyncThunk(
    "leave/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateLeaveAction(newData)
            console.log("edit leave", response)
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)


const leaveRequestSlice = createSlice({
    name: "leaveRequest",
    initialState: {
        leaveRequest: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            //GET
            .addCase(getLeaveRequest.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getLeaveRequest.fulfilled, (state, action) => {
                state.isLoading = false;
                state.leaveRequest = action.payload.data;

            })
            .addCase(getLeaveRequest.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

        //PUT
        .addCase(editLeaveRequest.pending, (state) => {
            state.actionLoader = true,
                state.error = null
        })
        .addCase(editLeaveRequest.fulfilled, (state, action) => {
            state.actionLoader = false;

        })
        .addCase(editLeaveRequest.rejected, (state, action) => {
            state.actionLoader = false;
            state.error = action.payload
        })


    }
})
export default leaveRequestSlice.reducer;